
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-node-anchor-demo-node-anchor-playground"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.en.md?type=demo')
};